




























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class InputSerial extends Vue {
  @Prop()
  value!: string;
  @Prop()
  maxlength!: number;
  @Prop()
  disabled!: boolean;
  @Prop({ default: false })
  forceTrim!: boolean;

  htmlStr = "<center>数字14桁を半角数字で<br />入力してください<br /></center>";

  str = "";
  mounted(): void {
    this.str = this.value;
  }

  change(val: string): void {
    if (this.forceTrim && val.length > this.maxlength) {
      setTimeout(() => {
        this.str = val.slice(0, this.maxlength);
      }, 1);
      this.$emit("change", val.slice(0, this.maxlength));
    } else {
      this.$emit("change", val);
    }
  }
}
